// react
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// reducers
import { imageApprovalReducer, ingredientApprovalReducer, jobsReducer, ordersReducer, proManagementReducer, adminProductsReducer, varietyApprovalReducer } from './admin';
import { reducerAuth } from './auth/reducer';
import { articleReducer, articlesReducer, categoriesReducer, relatedArticlesReducer, tagsReducer } from './blog';
import { brevoContactsReducer, brevoFoldersReducer, brevoListReducer, brevoTemplatesReducer, brevoUtilityReducer } from './brevo';
import { countriesReducer, cultivationTipsReducer, funFactReducer, globalStatsReducer, membershipsPeriodsReducer, mushroomsReducer, newsReducer, specialtiesReducer, trendingDataReducer, uielementsReducer } from './resources';
import { cartReducer, checkoutReducer, couponsReducer, invoicesReducer, membershipsReducer, pricesReducer, productsReducer, userOrdersReducer } from './shop';
import { reducerSporexpertUser } from './sporexpertuser/reducer';
import { calcReducer, quizReducer } from './tools';
import { organizationReducer, noteReducer, recipeReducer, spawnReducer, configReducer, mushroomReducer, batchReducer, stageReducer, monitoringReducer, sensorReducer, sensorManagementReducer, apiKeyReducer, labelReducer } from './slices/mycolab';
import { alertsReducer } from './slices/mycore';
import archivesReducer from './mycore/archives/reducer';
import communityReducer from './mycore/community/reducer';
import { taskAlertsReducer } from './mycore/taskAlerts';
import { ingredientsReducer } from './mycore/ingredients/reducer';
import userLimitsReducer from './slices/userLimits';
import { messagesReducer } from './messages';
import { gamificationReducer } from './gamification';

// ----------------------------------------------------------------------

// devtools for redux
const reduxTool = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();


const adminReducer = combineReducers({
  imageApproval: imageApprovalReducer,
  ingredientApproval: ingredientApprovalReducer,
  jobs: jobsReducer,
  orders: ordersReducer,
  proManagement: proManagementReducer,
  products: adminProductsReducer,
  varietyApproval: varietyApprovalReducer,
});


const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
  ...(process.env.REACT_APP_IS_PRODUCTION === 'true' ? {} : { reduxTool }),

};

const shopReducer = combineReducers({
  cart: cartReducer,
  checkout: checkoutReducer,
  prices: pricesReducer,
  coupons: couponsReducer,
  invoices: invoicesReducer,
  memberships: membershipsReducer,
  products: productsReducer,
  userOrders: userOrdersReducer,
});



const blogReducer = combineReducers({
  tags: tagsReducer,
  article: articleReducer,
  articles: articlesReducer,
  categories: categoriesReducer,
  relatedArticles: relatedArticlesReducer,
});

const brevoReducer = combineReducers({
  list: brevoListReducer,
  utility: brevoUtilityReducer,
  folders: brevoFoldersReducer,
  contacts: brevoContactsReducer,
  templates: brevoTemplatesReducer,
});

const resourcesReducer = combineReducers({
  news: newsReducer,
  funFact: funFactReducer,
  cultivationTips: cultivationTipsReducer,
  globalStats: globalStatsReducer,
  trendingData: trendingDataReducer,
  countries: countriesReducer,
  specialties: specialtiesReducer,
  membershipsPeriod: membershipsPeriodsReducer,
  uielements: uielementsReducer,
  mushrooms: mushroomsReducer,
});

const toolsReducer = combineReducers({
  calc: calcReducer,
  quiz: quizReducer,
})

// Persist config for mycolab - persist organization selection for better UX
const mycolabPersistConfig = {
  key: 'mycolab',
  storage,
  whitelist: ['organization'], // Persist organization state to maintain context between sessions
};

const mycolabReducer = persistReducer(
  mycolabPersistConfig,
  combineReducers({
    organization: organizationReducer,
    note: noteReducer,
    recipe: recipeReducer,
    spawn: spawnReducer,
    config: configReducer,
    mushroom: mushroomReducer,
    batch: batchReducer,
    stage: stageReducer,
    monitoring: monitoringReducer,
    sensor: sensorReducer,
    sensorManagement: sensorManagementReducer,
    apiKey: apiKeyReducer,
    label: labelReducer,
  })
)

// Persist config for mycore - only persist alerts for notification monitoring
const mycorePersistConfig = {
  key: 'mycore',
  storage,
  whitelist: ['alerts'], // Only persist alerts to enable cross-page notification monitoring
};

const mycoreReducer = persistReducer(
  mycorePersistConfig,
  combineReducers({
    alerts: alertsReducer,
    archives: archivesReducer,
    community: communityReducer,
    taskAlerts: taskAlertsReducer,
    ingredients: ingredientsReducer,
  })
)

const rootReducer = combineReducers({
  admin: adminReducer,
  auth: reducerAuth,
  shop: shopReducer,
  blog: blogReducer,
  brevo: brevoReducer,
  resources: resourcesReducer,
  tools: toolsReducer,
  mycolab: mycolabReducer,
  mycore: mycoreReducer,
  userLimits: userLimitsReducer,
  messages: messagesReducer,
  gamification: gamificationReducer,

  usersporexpert: reducerSporexpertUser,
});

export { rootPersistConfig, rootReducer };
